import { type FactoryTypeText } from '../types/factory';
import { type PlantTypeText } from '../types/plant';
import { type ResourceTypeText } from '../types/resource';

export const resourceLevels: Record<ResourceTypeText, number> = {
  wood: 0,
  cotton: 1,
  bulk: 4,
  iron: 7,
  oil: 9,
  precious: 21,
};
export const materialLevels: Record<PlantTypeText, number> = {
  lumber: 0,
  textiles: 1,
  bricks: 4,
  paper: 5,
  steel: 7,
  plastic: 9,
  glass: 16,
  fuels_and_oils: 19,
  microchips: 21,
};
export const factoryLevels: Record<FactoryTypeText, number> = {
  furniture_factory: 0,
  garment_factory: 1,
  printing_factory: 5,
  homeware: 6,
  toolmaking: 7,
  childrens_goods: 11,
  musical_equipment: 13,
  electronics: 21,
  machinery: 26,
};
